<template>
  <div id="author-questionnaire-dialog">
    <ipub-model :title="'Author Questionnaire Summary'"
                width="840px"
                :visable="isVisable"
                :showFooter="false"
                @cancel="cancel">
      <ipub-table :columns="columns"
                  border
                  :pagination="false"
                  :dataSource="dataSource">
        <template v-slot:answer="{text, record}">
          <template v-if="text === 'SINGLE'">
            {{record.questionOptionObj[+record.checkedOption].answer}}
            <template v-if="record.supplyAnswer"> - {{record.supplyAnswer}}</template>
          </template>
          <template v-else-if="text === 'MULTIPLE'">
            {{record.checkedOption}}
          </template>
          <template v-else-if="text === 'QA'">
            {{record.answer}}
          </template>
          <template v-else>- -</template>
        </template>
      </ipub-table>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { editor } from '../../../../api/editor'
const columns = [
  {
    title: '',
    enTitle: 'Questions',
    width: 200,
    dataIndex: 'questionContent',
  },
  {
    title: '',
    enTitle: 'Answer',
    width: 200,
    dataIndex: 'type',
    slot: 'answer'
  }
]
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      columns,
      dataSource: [],
    }
  },
  computed: {
    ...mapGetters({
      domain: 'getDomain',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.dataSource = []
      } else {
        this.getList()
      }
    }
  },
  methods: {
    async getList () {
      const fun = this.inputData.manuscriptId ? editor.authorQuestionnaire : editor.manuscriptQuestionnaire
      this.dataSource = await fun(this.inputData.id, {
        sign: this.inputData.sign,
        manuscriptId: this.inputData.manuscriptId
      })
      this.dataSource.forEach(item => {
        item.questionOptionObj = JSON.parse(item.questionOption)
      })
    },
    cancel () {
      this.$emit('cancel')
    },
  }
}
</script>

<style lang="scss" scoped>
</style>
